//Margin conventions
var margin = {top: 20, right: 10, bottom: 45, left: 45};

var widther = d3.select(".gia-chart").node().clientWidth;

var width = widther - margin.left - margin.right,
    height = 345 - margin.top - margin.bottom;

//Comma format
format = d3.format("0,000"); 

//Appends the svg to the chart-container div
var svg = d3.select(".gia-chart").append("svg")
  .attr("width", width + margin.left + margin.right)
  .attr("height", height + margin.top + margin.bottom)
  .append("g")
  .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

//Creates the xScale 
var xScale = d3.scale.linear()
  .range([0, width]);

//Creates the yScale
var yScale = d3.scale.linear()
  .range([height, 0]);

//Defines the y axis styles
var yAxis = d3.svg.axis()
  .scale(yScale)
  .tickSize(-width)
  .tickPadding(8)
  .ticks(6)
  .tickFormat(function(d) { return format(d); })
  .orient("left");

//line function convention (feeds an array)
var eximLine = d3.svg.line()
  .x(function(d) { return xScale(d.year); })
  .y(function(d) { return yScale(d.eximValue); });

var cppLine = d3.svg.line()
  .x(function(d) { return xScale(d.year); })
  .y(function(d) { return yScale(d.cppValue); });   

//Loads the data
d3.csv("data/emissions.csv", ready);

function ready(err, data) {

  if (err) throw "error loading data";

  //FORMAT data
  data.forEach(function(d) {
    d.eximValue = +d.eximValue;
    d.cppValue = +d.cppValue;
    d.year = +d.year;
  });
  
  //Organizes the data  
  data.sort(function(a,b) { return a.year - b.year; });
  var maxY = d3.max(data, function(d) { return d.eximValue; });
  var maxX = d3.max(data, function(d) { return d.year; });

  //Area
  var indexes = d3.range(data.length); 

   var area = d3.svg.area()
      .x(function(d) {return xScale(d.year); }) 
      .y0(function(d) { return yScale(d.eximValue); })
      .y1(function(d) { return yScale(d.cppValue); });      

  //Defines the y axis styles
  var xAxis = d3.svg.axis()
    .scale(xScale)
    .tickPadding(8)
    .orient("bottom")
    .ticks(12);   

  //Defines the xScale max
  xScale.domain(d3.extent(data, function(d) { return d.year; }));

  //Defines the yScale max
  yScale.domain([-3000, 3000]);

  //Appends the y axis
  var yAxisGroup = svg.append("g")
    .attr("class", "y axis")
    .call(yAxis)
    .selectAll("g")
    .classed("g-baseline", function(d) {return d == 0});

  //Appends the x axis    
  var xAxisGroup = svg.append("g")
    .attr("class", "x axis")
    .attr("transform", "translate(0," + height + ")")
    .call(xAxis);  

  //Area in between
  var drawarea = svg.append("path")
    .datum(data)
    .attr("class", "area")
    .attr("d", area);    

  //data join for paths 
  var draweximLine = svg.append("path")
    .datum(data)
    .attr("class", "eximLine")
    .attr("d", eximLine);

  //data join for paths 
  var drawcppLine = svg.append("path")
    .datum(data)
    .attr("class", "cppLine")
    .attr("d", cppLine);  

  //Adding circle label  
  var labelElements = svg.append("g")
    .attr("class", "fiddly-bits")  

  var dotExim = labelElements.selectAll(".g-label-element")
    .data(data.filter(function(d) { return d.year == maxX; }))
    .enter().append("g")
    .attr("class", "g-label-element")
    .attr("transform", function(d) { return "translate(" + xScale(d.year) + "," + yScale(d.eximValue) + ")"; } );

  dotExim.append("circle")
    .attr("r", 3)
    .attr("class", "g-label-circle");

  dotExim.append("text")
    .attr("x", -5)
    .attr("y",-10)
    .text("EXIM projects: 2.46 billion")
    .attr("class", "g-label-text");  

  var dotcpp = labelElements.selectAll(".g-label-element2")
    .data(data.filter(function(d) { return d.year == maxX; }))
    .enter().append("g")
    .attr("class", "g-label-element2")
    .attr("transform", function(d) { return "translate(" + xScale(d.year) + "," + yScale(d.cppValue) + ")"; } );

  dotcpp.append("circle")
    .attr("r", 3)
    .attr("class", "g-label-circle2");

  dotcpp.append("text")
    .attr("x", -5)
    .attr("y",10)
    .text("Clean Power Plan: 2.49 billion")
    .attr("class", "g-label-text2");   

  //Adding axi label
  var axisLabel = svg.append("text")
    .text("Years")
    .attr("x", width/2.1)
    .attr("y", height/0.87)
    .attr("class", "axisLabel");       
      
//RESPONSIVENESS
  d3.select(window).on("resize", resized);

  function resized() {

    //new margin
    var newMargin = {top: 20, right: 10, bottom: 45, left:45};

    var newWidther = d3.select(".gia-chart").node().clientWidth;

    var newWidth = newWidther - newMargin.left - newMargin.right;

    //Change the width of the svg
    d3.select("svg")
      .attr("width", newWidth + newMargin.left + newMargin.right);

    //Change the xScale
    xScale
      .range([0, newWidth]);

    //Update the blue line
    eximLine = d3.svg.line()
      .x(function(d) { return xScale(d.year); })
      .y(function(d) { return yScale(d.eximValue); });

    d3.selectAll('.eximLine')
      .attr("d", eximLine);

    //Update the red line
    cppLine = d3.svg.line()
      .x(function(d) { return xScale(d.year); })
      .y(function(d) { return yScale(d.cppValue); });

    d3.selectAll('.cppLine')
      .attr("d", cppLine);  
    
    //Updates xAxis
    d3.selectAll(".x.axis")
         .call(xAxis);     

    //Updates ticks
    xAxis
      .scale(xScale)
      .ticks(12);

    //Updates yAxis
    d3.selectAll(".y.axis")
      .call(yAxis); 

    yAxis
      .tickSize(-newWidth);

       //Updates circle labels 
    dotExim
      .attr("transform", function(d) { return "translate(" + xScale(d.year) + "," + yScale(d.eximValue) + ")"; } );

       //Updates circle labels 
    dotcpp
      .attr("transform", function(d) { return "translate(" + xScale(d.year) + "," + yScale(d.cppValue) + ")"; } );  

    //Updates area
    area = d3.svg.area()
      .x(function(d) {return xScale(d.year); }) 
      .y0(function(d) { return yScale(d.eximValue); })
      .y1(function(d) { return yScale(d.cppValue); });

    d3.selectAll('.area')
      .attr("d", area); 

  axisLabel
    .attr("x", newWidth/2.1)   

  };    

}